var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16"
  }, [_vm._v("발송리스트")]), _c('v-divider', {
    staticClass: "primary border-2 mb-12 mb-lg-24"
  }), _vm._l(_vm.textings, function (item) {
    var _item$createdAt, _item$createdAt$toDat;
    return [_c('v-card', {
      key: item._id,
      staticClass: "texing-item",
      attrs: {
        "outlined": "",
        "rounded": ""
      }
    }, [_c('div', {
      staticClass: "pa-20"
    }, [_c('v-row', {
      attrs: {
        "align-md": "center"
      }
    }, [_c('v-col', {
      staticClass: "texing-item__detail",
      attrs: {
        "cols": "12",
        "md": ""
      }
    }, [_c('p', {
      staticClass: "page-text--sm grey-9--text"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$createdAt = item.createdAt) === null || _item$createdAt === void 0 ? void 0 : (_item$createdAt$toDat = _item$createdAt.toDateTime) === null || _item$createdAt$toDat === void 0 ? void 0 : _item$createdAt$toDat.call(_item$createdAt)) + " ")]), _c('p', {
      staticClass: "page-text line-height-15"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.message) + " ")]), _vm.showsAddressees ? _c('v-chip-group', {
      staticClass: "mt-12",
      attrs: {
        "column": ""
      }
    }, [_vm._l(item.addressees, function (addressee) {
      return [_c('v-chip', {
        key: addressee._user,
        attrs: {
          "small": ""
        }
      }, [_vm._v(" " + _vm._s(addressee.name) + " / " + _vm._s(addressee.phone) + " ")])];
    })], 2) : _vm._e()], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-chip', {
      staticClass: "rounded-sm",
      attrs: {
        "large": "",
        "color": "grey-f1"
      }
    }, [_c('span', {
      staticClass: "grey-13--text"
    }, [_vm._v(" 발송완료 "), _c('v-icon', {
      staticClass: "ml-4",
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-check")])], 1)])], 1)], 1)], 1)])];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }